// extracted by mini-css-extract-plugin
module.exports = {"lineSpace":"LineSpace_lineSpace__Lkoov"};